import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { AppConfig } from 'client/app/app.config';
import { Entity } from '@cureskin/api-client-rn';
import { OrderService } from '@services/order-service/order.service';


@Component({
  selector: 'order-shipped',
  templateUrl: './order-shipped.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class OrderShippedComponent implements OnInit {
  public readonly orderService: OrderService = inject(OrderService);
  public readonly appConfig: AppConfig = inject(AppConfig);

  @Input('order') order: any;
  @Output('addEvents') addEvents: EventEmitter<any> = new EventEmitter();
  orderedProductsCount: number;
  cancelledProducts: Array<NonNullable<Entity['Order']['productApprovalDetails']>['productDetails'][number]> = [];
  shouldShowPartialOrderCancellationUI: boolean;
  cancelledProductsCount: number = 0;
  totalProductsCount: number = 0;

  constructor() {}

  ngOnInit(): void {
    const approvalData = this.orderService.initializeProductApprovalData(this.order);
    this.cancelledProducts = approvalData.cancelledProducts;
    this.orderedProductsCount = approvalData.orderedProductsCount;
    this.shouldShowPartialOrderCancellationUI = approvalData.shouldShowPartialOrderCancellationUI;
    this.cancelledProductsCount = approvalData.cancelledProductsCount;
    this.totalProductsCount = approvalData.totalProductsCount;
  }

  handleClick(): void {
    this.addEvents.emit();
  }
}
